import { customerHasLiveScoring } from 'src/data/accessRights';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerHasLiveScoring = () => {
  const currentCustomer = useCurrentCustomer();

  return customerHasLiveScoring(currentCustomer);
};
